var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02Javascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F7DF1E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2_",
    x: 67.5,
    y: 67.5,
    className: "st0",
    width: 365,
    height: 365
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    d: "M163.5,372.5l27.9-16.9c5.4,9.6,10.3,17.6,22,17.6c11.3,0,18.4-4.4,18.4-21.6V235.1h34.3v117.1 c0,35.5-20.8,51.7-51.2,51.7C187.5,403.9,171.6,389.7,163.5,372.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M284.8,368.8l27.9-16.2c7.4,12,16.9,20.8,33.8,20.8c14.2,0,23.3-7.1,23.3-16.9c0-11.8-9.3-15.9-25-22.8 l-8.6-3.7c-24.7-10.5-41.2-23.8-41.2-51.7c0-25.7,19.6-45.3,50.2-45.3c21.8,0,37.5,7.6,48.8,27.4l-26.7,17.1 c-5.9-10.5-12.2-14.7-22-14.7c-10,0-16.4,6.4-16.4,14.7c0,10.3,6.4,14.5,21.1,20.8l8.6,3.7c29.2,12.5,45.6,25.2,45.6,53.9 c0,30.9-24.3,47.8-56.8,47.8C315.4,403.9,294.8,388.7,284.8,368.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02Javascript);
export default __webpack_public_path__ + "static/media/02_javascript.3fde30955bbf42062bd71af30e199e25.svg";
export { ForwardRef as ReactComponent };